import http from './http'

/**
 * 按玩法配置拉取最新开奖
 * @param {{ url: string, method?: string, params?: object, data?: object }} drawRequest
 * @returns {Promise<import('axios').AxiosResponse>}
 */
export function fetchLatestDraw(drawRequest) {
  const { url, method = 'get', params, data, headers, baseURL, timeout } = drawRequest
  if (!url) return Promise.reject(new Error('drawRequest.url 不能为空'))
  const m = String(method).toLowerCase()
  const extra = { params, headers }
  if (baseURL !== undefined) extra.baseURL = baseURL
  if (timeout !== undefined) extra.timeout = timeout
  if (m === 'post' || m === 'put' || m === 'patch') {
    return http.request({
      url,
      method: m,
      ...extra,
      data: data != null ? data : {}
    })
  }
  return http.get(url, extra)
}

/**
 * 历史开奖分页（与最新开奖同数据形态：nums、special、zodiacList、colorList、issueNo、drawTime 等）
 * @param {{ type?: string, page?: number, size?: number }} params type 默认 new_HK6；size 最大 200（前后端双重限制）
 */
export function fetchDrawsPage(params = {}) {
  let { type, page = 1, size = 25 } = params
  let p = Number(page)
  let s = Number(size)
  if (!Number.isFinite(p) || p < 1) p = 1
  if (!Number.isFinite(s) || s < 1) s = 25
  if (s > 200) s = 200
  return http.get('/api/draws/page', {
    params: { type: String(type), page: p, size: s }
  })
}

/**
 * 香港 hk_lot_draws 历史列表（game=hk）
 * @param {{ lotteryType?: number|string, page?: number, size?: number }} params
 */
export function fetchHkLotDrawsList(params = {}) {
  let { lotteryType = 2, page = 1, size = 25 } = params
  let p = Number(page)
  let s = Number(size)
  if (!Number.isFinite(p) || p < 1) p = 1
  if (!Number.isFinite(s) || s < 1) s = 25
  if (s > 200) s = 200
  const lt =
    lotteryType != null && String(lotteryType).trim() !== '' ? lotteryType : 2
  return http.get('/api/hk-lot-draws/list', {
    params: { lotteryType: lt, page: p, size: s }
  })
}
